/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p><a parentName="p" {...{
        "href": "https://github.com/elsangedy/use-input-mask"
      }}>{`https://github.com/elsangedy/use-input-mask`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/text-mask/text-mask"
      }}>{`https://github.com/text-mask/text-mask`}</a></p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add use-input-mask
`}</code></pre>
    <h2 {...{
      "id": "hook"
    }}>{`Hook`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import useInputMask from 'use-input-mask'

const onChange = useInputMask({
  input,
  onChange,
  guide,
  keepCharPositions,
  mask,
  pipe,
  placeholderChar,
  showMask,
  initialValue,
})
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  